import { observer } from "mobx-react-lite";

import * as Node from "@/components/expression/utils/layout";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { EditNodeInput } from "@/components/input/EditNodeInput";
import { FunctionNodeModel } from "@/models/nodes/FunctionNodeModel";
import { isLabelChild } from "@/models/nodes/utils";
import { twMerge } from "@/utils/twMerge";

import type { ExpressionComponent } from "./types";

export const PlainTextNode: ExpressionComponent<"plainText"> = observer(function PlainTextNode({
  node,
  className,
}) {
  const { view } = useNodeStyle();
  const { fontSize, fontFeature } = node.getFont();

  let nodeFontSize = fontSize;
  const parentIsFunction = node.parent?.is(FunctionNodeModel);

  if (parentIsFunction && view === "compact-expression") {
    nodeFontSize = "16";
  } else if (fontSize && isLabelChild(node) && parseInt(fontSize, 10) > 18) {
    nodeFontSize = "18";
  }

  return (
    <EditNodeInput node={node} inputClassName={twMerge("rounded-full", className)}>
      <Node.Container node={node} dimension="narrow" className="before:content-zero-space">
        <Node.Value
          className={twMerge(
            view === "text" && "font-sans",
            nodeFontSize && `text-node-size-${nodeFontSize}`,
            fontFeature && `font-${fontFeature}`,
          )}
        >
          {node.value}
        </Node.Value>
      </Node.Container>
    </EditNodeInput>
  );
});
